import {createAsyncAction, createStandardAction} from "typesafe-actions";

export const setPaymentsIsReady = createStandardAction("@payments/SET_READY")();

export const purchase = createAsyncAction(
    "@payments/PURCHASE_REQUEST",
    "@payments/PURCHASE_SUCCESS",
    "@payments/PURCHASE_FAILURE"
)<string, string, string>();

export const consume = createAsyncAction(
    "@payments/CONSUME_REQUEST",
    "@payments/CONSUME_SUCCESS",
    "@payments/CONSUME_FAILURE"
)<string, string, string>();